'use client'

import { motion } from 'motion/react'
import { Trophy, Download, BarChart3, User } from 'lucide-react'
import { useState } from 'react'
import { useAuth } from '@/hooks/use-auth'

export function MK8DNav() {
  const { currentUser, signOut } = useAuth()
  const [isHoveringLogout, setIsHoveringLogout] = useState(false)

  const displayName =
    currentUser?.name?.trim() || currentUser?.email?.split('@')[0] || 'ACCOUNT'

  const onSignOut = async () => {
    try {
      await signOut()
      window.location.href = '/'
    } catch {
      window.location.href = '/sign-out'
    }
  }

  return (
    <motion.nav
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      className="fixed top-0 left-0 right-0 z-50 flex items-center justify-between px-6 py-4"
      style={{
        background:
          'linear-gradient(180deg, rgba(8,8,14,0.98) 0%, rgba(8,8,14,0.0) 100%)',
        backdropFilter: 'blur(12px)',
      }}
    >
      <div className="flex items-center gap-3">
        <img
          src="/assets/branding/mk8d-stats-logo-v2.png"
          alt="MK8D Stats"
          style={{ height: 42, width: 'auto' }}
        />
      </div>

      <div className="hidden md:flex items-center gap-1">
        {[
          { icon: User, label: 'Profile' },
          { icon: BarChart3, label: 'Stats' },
          { icon: Trophy, label: 'Leaderboard' },
          { icon: Download, label: 'Download' },
        ].map(({ icon: Icon, label }) => (
          <button
            key={label}
            onClick={() => {
              const el = document.getElementById(label.toLowerCase())
              el?.scrollIntoView({ behavior: 'smooth' })
            }}
            className="flex items-center gap-2 px-4 py-2 rounded-lg text-sm transition-all duration-200 hover:text-white"
            style={{
              fontFamily: "'Barlow Condensed', sans-serif",
              fontWeight: 600,
              letterSpacing: '0.08em',
              color: 'rgba(255,255,255,0.5)',
            }}
          >
            <Icon size={14} />
            {label.toUpperCase()}
          </button>
        ))}
      </div>

      {!currentUser ? (
        <motion.a
          whileHover={{ scale: 1.04 }}
          whileTap={{ scale: 0.97 }}
          href="/sign-in"
          className="relative px-5 py-2 rounded-lg text-sm font-bold overflow-hidden inline-flex"
          style={{
            fontFamily: "'Barlow Condensed', sans-serif",
            fontWeight: 700,
            letterSpacing: '0.1em',
            background: 'linear-gradient(90deg, #00eaff, #0077ff)',
            color: '#08080e',
          }}
        >
          CONNECT ACCOUNT
        </motion.a>
      ) : (
        <motion.button
          whileHover={{ scale: 1.04 }}
          whileTap={{ scale: 0.97 }}
          onMouseEnter={() => setIsHoveringLogout(true)}
          onMouseLeave={() => setIsHoveringLogout(false)}
          onClick={onSignOut}
          title="Click to sign out"
          className="relative px-5 py-2 rounded-lg text-sm font-bold overflow-hidden inline-flex"
          style={{
            fontFamily: "'Barlow Condensed', sans-serif",
            fontWeight: 700,
            letterSpacing: '0.1em',
            background: isHoveringLogout
              ? 'linear-gradient(90deg, #ff6b6b, #ff3b3b)'
              : 'linear-gradient(90deg, #00eaff, #0077ff)',
            color: '#08080e',
          }}
        >
          {isHoveringLogout ? 'SIGN OUT' : displayName.toUpperCase()}
        </motion.button>
      )}
    </motion.nav>
  )
}
